import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as types from "../actions/actionTypes";
import * as actions from "../actions/widthActions";

export default function widthReducer(state: number = 0, action: Action): number {

  if (isType(action, actions.widthChangedAction)) {
    const width = action.payload;
    return width;
  }

  return state;
};
